import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import LoadingComponent from "./commons/loader";
import { Layout, Menu, Icon, Modal, Spin, Avatar } from "antd";
import { actionCreators as authActionCreators } from "./modules/auth/reducer";

import "./App.css";

const { Content, Header } = Layout;
const { SubMenu } = Menu;
class App extends Component {
  state = { logoutVisible: false };

  onCollapse = collapsed => {
    this.setState({ collapsed });
  };

  showModal = () => {
    this.setState({
      logoutVisible: true
    });
  };

  onOk = () => this.props.logout(this.props.profile.id);

  hideModal = () => {
    this.setState({
      logoutVisible: false
    });
  };

  renderPrivatePage(profile) {
    return (
      <Layout style={{ minHeight: "100vh" }} className="dashboard">
        <Header>
          <Menu
            theme="light"
            mode="horizontal"
            defaultSelectedKeys={["/dashboard"]}
            selectedKeys={[window.location.pathname]}
            style={{ lineHeight: "64px" }}
          >
            <Menu.Item key="/logo">
              {profile.type === 1 || profile.type === 0 ? (
                <NavLink to="/clients/" className="nav-text">
                  <div className="kyn-logo">KnowYourNumbers</div>
                </NavLink>
              ) : (
                  <NavLink
                    to={`/clients/${profile.id}/company/`}
                    className="nav-text"
                  >
                    <div className="kyn-logo">KnowYourNumbers</div>
                  </NavLink>
                )}
            </Menu.Item>
            <Menu.Item key="/clients">
              {profile.type === 1 || profile.type === 0 ? (
                <NavLink to="/clients" className="nav-text">
                  <span>End Users</span>
                </NavLink>
              ) : (
                  <NavLink to={`/clients/${profile.id}/company/`} className="nav-text">
                    <span>My Companies</span>
                  </NavLink>
                )}
            </Menu.Item>
            {profile.type === 1 || profile.type === 0 ? (
              <Menu.Item key="/users">
                <NavLink to="/users" className="nav-text">
                  <span>Users</span>
                </NavLink>
              </Menu.Item>
            ) : null}
            <SubMenu
              // className="pull-right"
              style={{ float: "right" }}
              key="/profile"
              title={
                <span>
                  <Avatar
                    style={{ marginRight: "5px", backgroundColor: "#1890ff" }}
                  >
                    {this.props.profile &&
                      `${this.props.profile.name.first_name}`
                        .charAt(0)
                        .toUpperCase()}
                    {this.props.profile &&
                      `${this.props.profile.name.last_name}`
                        .charAt(0)
                        .toUpperCase()}
                  </Avatar>{" "}
                  {this.props.profile && this.props.profile.name.fullname}
                  <Icon style={{ marginLeft: "5px" }} type="down" />
                </span>
              }
            >
              <Menu.Item key="5">
                <NavLink to={`/profile/${profile.id}`}>Profile</NavLink>
              </Menu.Item>

              <Menu.Item key="7" onClick={this.showModal}>
                Sign out
              </Menu.Item>
            </SubMenu>
          </Menu>
        </Header>
        <Layout>
          <Content style={{ overflowX: "hidden" }}>
            {this.props.children}
          </Content>
          {/* <Footer /> */}
        </Layout>
        <Modal
          title="Signout"
          visible={this.state.logoutVisible}
          onOk={this.onOk}
          onCancel={this.hideModal}
          okText="Ok"
          cancelText="Cancel"
        >
          <p>Are you sure you want to signout?</p>
        </Modal>
      </Layout>
    );
  }

  renderLoginPage() {
    return (
      <div className="app">
        <main className="main">
          <Layout id="auth">
            <Content>{this.props.children}</Content>
          </Layout>
        </main>
      </div>
    );
  }

  render() {
    const { isAuthenticated, isLoading, profile } = this.props;

    if (isAuthenticated) {
      if (isLoading) {
        return <LoadingComponent isLoading={isLoading} />;
      }
      return this.renderPrivatePage(profile);
    } else {
      return (
        <div>
          <Spin spinning={isLoading}>{this.renderLoginPage()}</Spin>
        </div>
      );
    }
  }
}

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(authActionCreators, dispatch)
});
const mapStateToProps = (state, ownState) => {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    isLoading: state.auth.isLoading,
    profile: state.auth.profile
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/App.js